/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createRestaurant = /* GraphQL */ `
  mutation CreateRestaurant(
    $input: CreateRestaurantInput!
    $condition: ModelRestaurantConditionInput
  ) {
    createRestaurant(input: $input, condition: $condition) {
      id
      name
      userId
      groupName
      restaurantUrl
      displayDate
      displayLogo
      displayCurrencySymbol
      introduction
      logoKey
      displayLogoInQRCode
      backgroundImageKey
      displayBackground
      restaurantName {
        font
        color
        textstyle
        format
      }
      dateText {
        font
        color
        textstyle
        format
      }
      descriptionText {
        font
        color
        textstyle
        format
      }
      menusPosition
      paidMenus
      migratedMenuId
      paidMenuImages
      bookmarksEnabled
      paidBookmarks
      loadSectionOnly
      cognitoUsername
      zoomDisabled
      createdAt
      updatedAt
      menus {
        items {
          id
          name
          description
          qrCodeImage
          menuUrl
          fileLocation
          isPublished
          menuLayout
          createdAt
          updatedAt
          restaurant {
            id
            name
            userId
            groupName
            restaurantUrl
            displayDate
            displayLogo
            displayCurrencySymbol
            introduction
            logoKey
            displayLogoInQRCode
            backgroundImageKey
            displayBackground
            restaurantName {
              font
              color
              textstyle
              format
            }
            dateText {
              font
              color
              textstyle
              format
            }
            descriptionText {
              font
              color
              textstyle
              format
            }
            menusPosition
            paidMenus
            migratedMenuId
            paidMenuImages
            bookmarksEnabled
            paidBookmarks
            loadSectionOnly
            cognitoUsername
            zoomDisabled
            createdAt
            updatedAt
            menus {
              nextToken
            }
          }
          menuSetting {
            id
            displayDate
            displayCurrencySymbol
            displayLogo
            introduction
            logoKey
            headerOne {
              font
              color
              textstyle
              format
            }
            headerTwo {
              font
              color
              textstyle
              format
            }
            headerThree {
              font
              color
              textstyle
              format
            }
            headerFour {
              font
              color
              textstyle
              format
            }
            normalText {
              font
              color
              textstyle
              format
            }
            subtext {
              font
              color
              textstyle
              format
            }
            createdAt
            updatedAt
            menu {
              id
              name
              description
              qrCodeImage
              menuUrl
              fileLocation
              isPublished
              menuLayout
              createdAt
              updatedAt
            }
          }
        }
        nextToken
      }
    }
  }
`;
export const updateRestaurant = /* GraphQL */ `
  mutation UpdateRestaurant(
    $input: UpdateRestaurantInput!
    $condition: ModelRestaurantConditionInput
  ) {
    updateRestaurant(input: $input, condition: $condition) {
      id
      name
      userId
      groupName
      restaurantUrl
      displayDate
      displayLogo
      displayCurrencySymbol
      introduction
      logoKey
      displayLogoInQRCode
      backgroundImageKey
      displayBackground
      restaurantName {
        font
        color
        textstyle
        format
      }
      dateText {
        font
        color
        textstyle
        format
      }
      descriptionText {
        font
        color
        textstyle
        format
      }
      menusPosition
      paidMenus
      migratedMenuId
      paidMenuImages
      bookmarksEnabled
      paidBookmarks
      loadSectionOnly
      cognitoUsername
      zoomDisabled
      createdAt
      updatedAt
      menus {
        items {
          id
          name
          description
          qrCodeImage
          menuUrl
          fileLocation
          isPublished
          menuLayout
          createdAt
          updatedAt
          restaurant {
            id
            name
            userId
            groupName
            restaurantUrl
            displayDate
            displayLogo
            displayCurrencySymbol
            introduction
            logoKey
            displayLogoInQRCode
            backgroundImageKey
            displayBackground
            restaurantName {
              font
              color
              textstyle
              format
            }
            dateText {
              font
              color
              textstyle
              format
            }
            descriptionText {
              font
              color
              textstyle
              format
            }
            menusPosition
            paidMenus
            migratedMenuId
            paidMenuImages
            bookmarksEnabled
            paidBookmarks
            loadSectionOnly
            cognitoUsername
            zoomDisabled
            createdAt
            updatedAt
            menus {
              nextToken
            }
          }
          menuSetting {
            id
            displayDate
            displayCurrencySymbol
            displayLogo
            introduction
            logoKey
            headerOne {
              font
              color
              textstyle
              format
            }
            headerTwo {
              font
              color
              textstyle
              format
            }
            headerThree {
              font
              color
              textstyle
              format
            }
            headerFour {
              font
              color
              textstyle
              format
            }
            normalText {
              font
              color
              textstyle
              format
            }
            subtext {
              font
              color
              textstyle
              format
            }
            createdAt
            updatedAt
            menu {
              id
              name
              description
              qrCodeImage
              menuUrl
              fileLocation
              isPublished
              menuLayout
              createdAt
              updatedAt
            }
          }
        }
        nextToken
      }
    }
  }
`;
export const deleteRestaurant = /* GraphQL */ `
  mutation DeleteRestaurant(
    $input: DeleteRestaurantInput!
    $condition: ModelRestaurantConditionInput
  ) {
    deleteRestaurant(input: $input, condition: $condition) {
      id
      name
      userId
      groupName
      restaurantUrl
      displayDate
      displayLogo
      displayCurrencySymbol
      introduction
      logoKey
      displayLogoInQRCode
      backgroundImageKey
      displayBackground
      restaurantName {
        font
        color
        textstyle
        format
      }
      dateText {
        font
        color
        textstyle
        format
      }
      descriptionText {
        font
        color
        textstyle
        format
      }
      menusPosition
      paidMenus
      migratedMenuId
      paidMenuImages
      bookmarksEnabled
      paidBookmarks
      loadSectionOnly
      cognitoUsername
      zoomDisabled
      createdAt
      updatedAt
      menus {
        items {
          id
          name
          description
          qrCodeImage
          menuUrl
          fileLocation
          isPublished
          menuLayout
          createdAt
          updatedAt
          restaurant {
            id
            name
            userId
            groupName
            restaurantUrl
            displayDate
            displayLogo
            displayCurrencySymbol
            introduction
            logoKey
            displayLogoInQRCode
            backgroundImageKey
            displayBackground
            restaurantName {
              font
              color
              textstyle
              format
            }
            dateText {
              font
              color
              textstyle
              format
            }
            descriptionText {
              font
              color
              textstyle
              format
            }
            menusPosition
            paidMenus
            migratedMenuId
            paidMenuImages
            bookmarksEnabled
            paidBookmarks
            loadSectionOnly
            cognitoUsername
            zoomDisabled
            createdAt
            updatedAt
            menus {
              nextToken
            }
          }
          menuSetting {
            id
            displayDate
            displayCurrencySymbol
            displayLogo
            introduction
            logoKey
            headerOne {
              font
              color
              textstyle
              format
            }
            headerTwo {
              font
              color
              textstyle
              format
            }
            headerThree {
              font
              color
              textstyle
              format
            }
            headerFour {
              font
              color
              textstyle
              format
            }
            normalText {
              font
              color
              textstyle
              format
            }
            subtext {
              font
              color
              textstyle
              format
            }
            createdAt
            updatedAt
            menu {
              id
              name
              description
              qrCodeImage
              menuUrl
              fileLocation
              isPublished
              menuLayout
              createdAt
              updatedAt
            }
          }
        }
        nextToken
      }
    }
  }
`;
export const createMenu = /* GraphQL */ `
  mutation CreateMenu(
    $input: CreateMenuInput!
    $condition: ModelMenuConditionInput
  ) {
    createMenu(input: $input, condition: $condition) {
      id
      name
      description
      qrCodeImage
      menuUrl
      fileLocation
      isPublished
      menuLayout
      createdAt
      updatedAt
      restaurant {
        id
        name
        userId
        groupName
        restaurantUrl
        displayDate
        displayLogo
        displayCurrencySymbol
        introduction
        logoKey
        displayLogoInQRCode
        backgroundImageKey
        displayBackground
        restaurantName {
          font
          color
          textstyle
          format
        }
        dateText {
          font
          color
          textstyle
          format
        }
        descriptionText {
          font
          color
          textstyle
          format
        }
        menusPosition
        paidMenus
        migratedMenuId
        paidMenuImages
        bookmarksEnabled
        paidBookmarks
        loadSectionOnly
        cognitoUsername
        zoomDisabled
        createdAt
        updatedAt
        menus {
          items {
            id
            name
            description
            qrCodeImage
            menuUrl
            fileLocation
            isPublished
            menuLayout
            createdAt
            updatedAt
            restaurant {
              id
              name
              userId
              groupName
              restaurantUrl
              displayDate
              displayLogo
              displayCurrencySymbol
              introduction
              logoKey
              displayLogoInQRCode
              backgroundImageKey
              displayBackground
              menusPosition
              paidMenus
              migratedMenuId
              paidMenuImages
              bookmarksEnabled
              paidBookmarks
              loadSectionOnly
              cognitoUsername
              zoomDisabled
              createdAt
              updatedAt
            }
            menuSetting {
              id
              displayDate
              displayCurrencySymbol
              displayLogo
              introduction
              logoKey
              createdAt
              updatedAt
            }
          }
          nextToken
        }
      }
      menuSetting {
        id
        displayDate
        displayCurrencySymbol
        displayLogo
        introduction
        logoKey
        headerOne {
          font
          color
          textstyle
          format
        }
        headerTwo {
          font
          color
          textstyle
          format
        }
        headerThree {
          font
          color
          textstyle
          format
        }
        headerFour {
          font
          color
          textstyle
          format
        }
        normalText {
          font
          color
          textstyle
          format
        }
        subtext {
          font
          color
          textstyle
          format
        }
        createdAt
        updatedAt
        menu {
          id
          name
          description
          qrCodeImage
          menuUrl
          fileLocation
          isPublished
          menuLayout
          createdAt
          updatedAt
          restaurant {
            id
            name
            userId
            groupName
            restaurantUrl
            displayDate
            displayLogo
            displayCurrencySymbol
            introduction
            logoKey
            displayLogoInQRCode
            backgroundImageKey
            displayBackground
            restaurantName {
              font
              color
              textstyle
              format
            }
            dateText {
              font
              color
              textstyle
              format
            }
            descriptionText {
              font
              color
              textstyle
              format
            }
            menusPosition
            paidMenus
            migratedMenuId
            paidMenuImages
            bookmarksEnabled
            paidBookmarks
            loadSectionOnly
            cognitoUsername
            zoomDisabled
            createdAt
            updatedAt
            menus {
              nextToken
            }
          }
          menuSetting {
            id
            displayDate
            displayCurrencySymbol
            displayLogo
            introduction
            logoKey
            headerOne {
              font
              color
              textstyle
              format
            }
            headerTwo {
              font
              color
              textstyle
              format
            }
            headerThree {
              font
              color
              textstyle
              format
            }
            headerFour {
              font
              color
              textstyle
              format
            }
            normalText {
              font
              color
              textstyle
              format
            }
            subtext {
              font
              color
              textstyle
              format
            }
            createdAt
            updatedAt
            menu {
              id
              name
              description
              qrCodeImage
              menuUrl
              fileLocation
              isPublished
              menuLayout
              createdAt
              updatedAt
            }
          }
        }
      }
    }
  }
`;
export const updateMenu = /* GraphQL */ `
  mutation UpdateMenu(
    $input: UpdateMenuInput!
    $condition: ModelMenuConditionInput
  ) {
    updateMenu(input: $input, condition: $condition) {
      id
      name
      description
      qrCodeImage
      menuUrl
      fileLocation
      isPublished
      menuLayout
      createdAt
      updatedAt
      restaurant {
        id
        name
        userId
        groupName
        restaurantUrl
        displayDate
        displayLogo
        displayCurrencySymbol
        introduction
        logoKey
        displayLogoInQRCode
        backgroundImageKey
        displayBackground
        restaurantName {
          font
          color
          textstyle
          format
        }
        dateText {
          font
          color
          textstyle
          format
        }
        descriptionText {
          font
          color
          textstyle
          format
        }
        menusPosition
        paidMenus
        migratedMenuId
        paidMenuImages
        bookmarksEnabled
        paidBookmarks
        loadSectionOnly
        cognitoUsername
        zoomDisabled
        createdAt
        updatedAt
        menus {
          items {
            id
            name
            description
            qrCodeImage
            menuUrl
            fileLocation
            isPublished
            menuLayout
            createdAt
            updatedAt
            restaurant {
              id
              name
              userId
              groupName
              restaurantUrl
              displayDate
              displayLogo
              displayCurrencySymbol
              introduction
              logoKey
              displayLogoInQRCode
              backgroundImageKey
              displayBackground
              menusPosition
              paidMenus
              migratedMenuId
              paidMenuImages
              bookmarksEnabled
              paidBookmarks
              loadSectionOnly
              cognitoUsername
              zoomDisabled
              createdAt
              updatedAt
            }
            menuSetting {
              id
              displayDate
              displayCurrencySymbol
              displayLogo
              introduction
              logoKey
              createdAt
              updatedAt
            }
          }
          nextToken
        }
      }
      menuSetting {
        id
        displayDate
        displayCurrencySymbol
        displayLogo
        introduction
        logoKey
        headerOne {
          font
          color
          textstyle
          format
        }
        headerTwo {
          font
          color
          textstyle
          format
        }
        headerThree {
          font
          color
          textstyle
          format
        }
        headerFour {
          font
          color
          textstyle
          format
        }
        normalText {
          font
          color
          textstyle
          format
        }
        subtext {
          font
          color
          textstyle
          format
        }
        createdAt
        updatedAt
        menu {
          id
          name
          description
          qrCodeImage
          menuUrl
          fileLocation
          isPublished
          menuLayout
          createdAt
          updatedAt
          restaurant {
            id
            name
            userId
            groupName
            restaurantUrl
            displayDate
            displayLogo
            displayCurrencySymbol
            introduction
            logoKey
            displayLogoInQRCode
            backgroundImageKey
            displayBackground
            restaurantName {
              font
              color
              textstyle
              format
            }
            dateText {
              font
              color
              textstyle
              format
            }
            descriptionText {
              font
              color
              textstyle
              format
            }
            menusPosition
            paidMenus
            migratedMenuId
            paidMenuImages
            bookmarksEnabled
            paidBookmarks
            loadSectionOnly
            cognitoUsername
            zoomDisabled
            createdAt
            updatedAt
            menus {
              nextToken
            }
          }
          menuSetting {
            id
            displayDate
            displayCurrencySymbol
            displayLogo
            introduction
            logoKey
            headerOne {
              font
              color
              textstyle
              format
            }
            headerTwo {
              font
              color
              textstyle
              format
            }
            headerThree {
              font
              color
              textstyle
              format
            }
            headerFour {
              font
              color
              textstyle
              format
            }
            normalText {
              font
              color
              textstyle
              format
            }
            subtext {
              font
              color
              textstyle
              format
            }
            createdAt
            updatedAt
            menu {
              id
              name
              description
              qrCodeImage
              menuUrl
              fileLocation
              isPublished
              menuLayout
              createdAt
              updatedAt
            }
          }
        }
      }
    }
  }
`;
export const deleteMenu = /* GraphQL */ `
  mutation DeleteMenu(
    $input: DeleteMenuInput!
    $condition: ModelMenuConditionInput
  ) {
    deleteMenu(input: $input, condition: $condition) {
      id
      name
      description
      qrCodeImage
      menuUrl
      fileLocation
      isPublished
      menuLayout
      createdAt
      updatedAt
      restaurant {
        id
        name
        userId
        groupName
        restaurantUrl
        displayDate
        displayLogo
        displayCurrencySymbol
        introduction
        logoKey
        displayLogoInQRCode
        backgroundImageKey
        displayBackground
        restaurantName {
          font
          color
          textstyle
          format
        }
        dateText {
          font
          color
          textstyle
          format
        }
        descriptionText {
          font
          color
          textstyle
          format
        }
        menusPosition
        paidMenus
        migratedMenuId
        paidMenuImages
        bookmarksEnabled
        paidBookmarks
        loadSectionOnly
        cognitoUsername
        zoomDisabled
        createdAt
        updatedAt
        menus {
          items {
            id
            name
            description
            qrCodeImage
            menuUrl
            fileLocation
            isPublished
            menuLayout
            createdAt
            updatedAt
            restaurant {
              id
              name
              userId
              groupName
              restaurantUrl
              displayDate
              displayLogo
              displayCurrencySymbol
              introduction
              logoKey
              displayLogoInQRCode
              backgroundImageKey
              displayBackground
              menusPosition
              paidMenus
              migratedMenuId
              paidMenuImages
              bookmarksEnabled
              paidBookmarks
              loadSectionOnly
              cognitoUsername
              zoomDisabled
              createdAt
              updatedAt
            }
            menuSetting {
              id
              displayDate
              displayCurrencySymbol
              displayLogo
              introduction
              logoKey
              createdAt
              updatedAt
            }
          }
          nextToken
        }
      }
      menuSetting {
        id
        displayDate
        displayCurrencySymbol
        displayLogo
        introduction
        logoKey
        headerOne {
          font
          color
          textstyle
          format
        }
        headerTwo {
          font
          color
          textstyle
          format
        }
        headerThree {
          font
          color
          textstyle
          format
        }
        headerFour {
          font
          color
          textstyle
          format
        }
        normalText {
          font
          color
          textstyle
          format
        }
        subtext {
          font
          color
          textstyle
          format
        }
        createdAt
        updatedAt
        menu {
          id
          name
          description
          qrCodeImage
          menuUrl
          fileLocation
          isPublished
          menuLayout
          createdAt
          updatedAt
          restaurant {
            id
            name
            userId
            groupName
            restaurantUrl
            displayDate
            displayLogo
            displayCurrencySymbol
            introduction
            logoKey
            displayLogoInQRCode
            backgroundImageKey
            displayBackground
            restaurantName {
              font
              color
              textstyle
              format
            }
            dateText {
              font
              color
              textstyle
              format
            }
            descriptionText {
              font
              color
              textstyle
              format
            }
            menusPosition
            paidMenus
            migratedMenuId
            paidMenuImages
            bookmarksEnabled
            paidBookmarks
            loadSectionOnly
            cognitoUsername
            zoomDisabled
            createdAt
            updatedAt
            menus {
              nextToken
            }
          }
          menuSetting {
            id
            displayDate
            displayCurrencySymbol
            displayLogo
            introduction
            logoKey
            headerOne {
              font
              color
              textstyle
              format
            }
            headerTwo {
              font
              color
              textstyle
              format
            }
            headerThree {
              font
              color
              textstyle
              format
            }
            headerFour {
              font
              color
              textstyle
              format
            }
            normalText {
              font
              color
              textstyle
              format
            }
            subtext {
              font
              color
              textstyle
              format
            }
            createdAt
            updatedAt
            menu {
              id
              name
              description
              qrCodeImage
              menuUrl
              fileLocation
              isPublished
              menuLayout
              createdAt
              updatedAt
            }
          }
        }
      }
    }
  }
`;
export const createMenuSetting = /* GraphQL */ `
  mutation CreateMenuSetting(
    $input: CreateMenuSettingInput!
    $condition: ModelMenuSettingConditionInput
  ) {
    createMenuSetting(input: $input, condition: $condition) {
      id
      displayDate
      displayCurrencySymbol
      displayLogo
      introduction
      logoKey
      headerOne {
        font
        color
        textstyle
        format
      }
      headerTwo {
        font
        color
        textstyle
        format
      }
      headerThree {
        font
        color
        textstyle
        format
      }
      headerFour {
        font
        color
        textstyle
        format
      }
      normalText {
        font
        color
        textstyle
        format
      }
      subtext {
        font
        color
        textstyle
        format
      }
      createdAt
      updatedAt
      menu {
        id
        name
        description
        qrCodeImage
        menuUrl
        fileLocation
        isPublished
        menuLayout
        createdAt
        updatedAt
        restaurant {
          id
          name
          userId
          groupName
          restaurantUrl
          displayDate
          displayLogo
          displayCurrencySymbol
          introduction
          logoKey
          displayLogoInQRCode
          backgroundImageKey
          displayBackground
          restaurantName {
            font
            color
            textstyle
            format
          }
          dateText {
            font
            color
            textstyle
            format
          }
          descriptionText {
            font
            color
            textstyle
            format
          }
          menusPosition
          paidMenus
          migratedMenuId
          paidMenuImages
          bookmarksEnabled
          paidBookmarks
          loadSectionOnly
          cognitoUsername
          zoomDisabled
          createdAt
          updatedAt
          menus {
            items {
              id
              name
              description
              qrCodeImage
              menuUrl
              fileLocation
              isPublished
              menuLayout
              createdAt
              updatedAt
            }
            nextToken
          }
        }
        menuSetting {
          id
          displayDate
          displayCurrencySymbol
          displayLogo
          introduction
          logoKey
          headerOne {
            font
            color
            textstyle
            format
          }
          headerTwo {
            font
            color
            textstyle
            format
          }
          headerThree {
            font
            color
            textstyle
            format
          }
          headerFour {
            font
            color
            textstyle
            format
          }
          normalText {
            font
            color
            textstyle
            format
          }
          subtext {
            font
            color
            textstyle
            format
          }
          createdAt
          updatedAt
          menu {
            id
            name
            description
            qrCodeImage
            menuUrl
            fileLocation
            isPublished
            menuLayout
            createdAt
            updatedAt
            restaurant {
              id
              name
              userId
              groupName
              restaurantUrl
              displayDate
              displayLogo
              displayCurrencySymbol
              introduction
              logoKey
              displayLogoInQRCode
              backgroundImageKey
              displayBackground
              menusPosition
              paidMenus
              migratedMenuId
              paidMenuImages
              bookmarksEnabled
              paidBookmarks
              loadSectionOnly
              cognitoUsername
              zoomDisabled
              createdAt
              updatedAt
            }
            menuSetting {
              id
              displayDate
              displayCurrencySymbol
              displayLogo
              introduction
              logoKey
              createdAt
              updatedAt
            }
          }
        }
      }
    }
  }
`;
export const updateMenuSetting = /* GraphQL */ `
  mutation UpdateMenuSetting(
    $input: UpdateMenuSettingInput!
    $condition: ModelMenuSettingConditionInput
  ) {
    updateMenuSetting(input: $input, condition: $condition) {
      id
      displayDate
      displayCurrencySymbol
      displayLogo
      introduction
      logoKey
      headerOne {
        font
        color
        textstyle
        format
      }
      headerTwo {
        font
        color
        textstyle
        format
      }
      headerThree {
        font
        color
        textstyle
        format
      }
      headerFour {
        font
        color
        textstyle
        format
      }
      normalText {
        font
        color
        textstyle
        format
      }
      subtext {
        font
        color
        textstyle
        format
      }
      createdAt
      updatedAt
      menu {
        id
        name
        description
        qrCodeImage
        menuUrl
        fileLocation
        isPublished
        menuLayout
        createdAt
        updatedAt
        restaurant {
          id
          name
          userId
          groupName
          restaurantUrl
          displayDate
          displayLogo
          displayCurrencySymbol
          introduction
          logoKey
          displayLogoInQRCode
          backgroundImageKey
          displayBackground
          restaurantName {
            font
            color
            textstyle
            format
          }
          dateText {
            font
            color
            textstyle
            format
          }
          descriptionText {
            font
            color
            textstyle
            format
          }
          menusPosition
          paidMenus
          migratedMenuId
          paidMenuImages
          bookmarksEnabled
          paidBookmarks
          loadSectionOnly
          cognitoUsername
          zoomDisabled
          createdAt
          updatedAt
          menus {
            items {
              id
              name
              description
              qrCodeImage
              menuUrl
              fileLocation
              isPublished
              menuLayout
              createdAt
              updatedAt
            }
            nextToken
          }
        }
        menuSetting {
          id
          displayDate
          displayCurrencySymbol
          displayLogo
          introduction
          logoKey
          headerOne {
            font
            color
            textstyle
            format
          }
          headerTwo {
            font
            color
            textstyle
            format
          }
          headerThree {
            font
            color
            textstyle
            format
          }
          headerFour {
            font
            color
            textstyle
            format
          }
          normalText {
            font
            color
            textstyle
            format
          }
          subtext {
            font
            color
            textstyle
            format
          }
          createdAt
          updatedAt
          menu {
            id
            name
            description
            qrCodeImage
            menuUrl
            fileLocation
            isPublished
            menuLayout
            createdAt
            updatedAt
            restaurant {
              id
              name
              userId
              groupName
              restaurantUrl
              displayDate
              displayLogo
              displayCurrencySymbol
              introduction
              logoKey
              displayLogoInQRCode
              backgroundImageKey
              displayBackground
              menusPosition
              paidMenus
              migratedMenuId
              paidMenuImages
              bookmarksEnabled
              paidBookmarks
              loadSectionOnly
              cognitoUsername
              zoomDisabled
              createdAt
              updatedAt
            }
            menuSetting {
              id
              displayDate
              displayCurrencySymbol
              displayLogo
              introduction
              logoKey
              createdAt
              updatedAt
            }
          }
        }
      }
    }
  }
`;
export const deleteMenuSetting = /* GraphQL */ `
  mutation DeleteMenuSetting(
    $input: DeleteMenuSettingInput!
    $condition: ModelMenuSettingConditionInput
  ) {
    deleteMenuSetting(input: $input, condition: $condition) {
      id
      displayDate
      displayCurrencySymbol
      displayLogo
      introduction
      logoKey
      headerOne {
        font
        color
        textstyle
        format
      }
      headerTwo {
        font
        color
        textstyle
        format
      }
      headerThree {
        font
        color
        textstyle
        format
      }
      headerFour {
        font
        color
        textstyle
        format
      }
      normalText {
        font
        color
        textstyle
        format
      }
      subtext {
        font
        color
        textstyle
        format
      }
      createdAt
      updatedAt
      menu {
        id
        name
        description
        qrCodeImage
        menuUrl
        fileLocation
        isPublished
        menuLayout
        createdAt
        updatedAt
        restaurant {
          id
          name
          userId
          groupName
          restaurantUrl
          displayDate
          displayLogo
          displayCurrencySymbol
          introduction
          logoKey
          displayLogoInQRCode
          backgroundImageKey
          displayBackground
          restaurantName {
            font
            color
            textstyle
            format
          }
          dateText {
            font
            color
            textstyle
            format
          }
          descriptionText {
            font
            color
            textstyle
            format
          }
          menusPosition
          paidMenus
          migratedMenuId
          paidMenuImages
          bookmarksEnabled
          paidBookmarks
          loadSectionOnly
          cognitoUsername
          zoomDisabled
          createdAt
          updatedAt
          menus {
            items {
              id
              name
              description
              qrCodeImage
              menuUrl
              fileLocation
              isPublished
              menuLayout
              createdAt
              updatedAt
            }
            nextToken
          }
        }
        menuSetting {
          id
          displayDate
          displayCurrencySymbol
          displayLogo
          introduction
          logoKey
          headerOne {
            font
            color
            textstyle
            format
          }
          headerTwo {
            font
            color
            textstyle
            format
          }
          headerThree {
            font
            color
            textstyle
            format
          }
          headerFour {
            font
            color
            textstyle
            format
          }
          normalText {
            font
            color
            textstyle
            format
          }
          subtext {
            font
            color
            textstyle
            format
          }
          createdAt
          updatedAt
          menu {
            id
            name
            description
            qrCodeImage
            menuUrl
            fileLocation
            isPublished
            menuLayout
            createdAt
            updatedAt
            restaurant {
              id
              name
              userId
              groupName
              restaurantUrl
              displayDate
              displayLogo
              displayCurrencySymbol
              introduction
              logoKey
              displayLogoInQRCode
              backgroundImageKey
              displayBackground
              menusPosition
              paidMenus
              migratedMenuId
              paidMenuImages
              bookmarksEnabled
              paidBookmarks
              loadSectionOnly
              cognitoUsername
              zoomDisabled
              createdAt
              updatedAt
            }
            menuSetting {
              id
              displayDate
              displayCurrencySymbol
              displayLogo
              introduction
              logoKey
              createdAt
              updatedAt
            }
          }
        }
      }
    }
  }
`;
export const createSubscription = /* GraphQL */ `
  mutation CreateSubscription(
    $account: AccountInput!
    $planId: ID!
    $paymentMethodId: ID!
  ) {
    createSubscription(
      account: $account
      planId: $planId
      paymentMethodId: $paymentMethodId
    ) {
      id
      userId
      planId
      stripeSubscriptionId
      status
      createdAt
      updatedAt
      plan {
        id
        name
        price {
          amount
          currency
          unit
        }
        description
        interval
        pricePerMonth {
          amount
          currency
          unit
        }
        pricePerYear {
          amount
          currency
          unit
        }
        active
        createdAt
        updatedAt
      }
      user {
        id
        cognitoUsername
        stripeCustomerIds
        createdAt
        updatedAt
      }
    }
  }
`;
